import * as Yup from 'yup';

import { Business } from '@barboxx/models';
import {
    BOX_STATUS_TYPE,
    BoxStatusType,
    BUSINESS_PICKUP_MODE,
    BusinessPickupMode,
} from '@barboxx/types';
import { enumToList, getMaxSalesCutoffBufferMinutes } from '@barboxx/utils';

// Generated by Copilot

export const BUSINESS_SCHEMA: Yup.ObjectSchema<Business.UpdateRequest> =
    Yup.object({}).shape({
        id: Yup.number().required(),
        active: Yup.boolean().default(false),
        placeId: Yup.string().required(),
        boxStatus: Yup.string<BoxStatusType>()
            .oneOf(enumToList(BOX_STATUS_TYPE), 'must match type of box status')
            .default('Setup Needed')
            .required(),
        taxRate: Yup.number().positive().min(0).max(1).required(),
        serviceFee: Yup.number().positive().min(0.99).required(),
        passCreditCardFeesToCustomer: Yup.boolean().default(false),
        pickupMode: Yup.string<BusinessPickupMode>()
            .oneOf(
                enumToList(BUSINESS_PICKUP_MODE),
                'must match a valid pickup mode'
            )
            .default(BUSINESS_PICKUP_MODE.Nfc)
            .required(),
        maxDistance: Yup.number().positive().min(25).max(100000).required(),
        lastCall: Yup.string().required(),
        orderSalesCutoffBufferMinutes: Yup.number()
            .integer()
            .min(0)
            .required()
            .test(
                'orderSalesCutoffBufferMinutes-max',
                'Sales cutoff buffer exceeds serving window.',
                function validateMaxSalesCutoffBuffer(value) {
                    if (typeof value !== 'number') {
                        return true;
                    }

                    const validationContext =
                        (this.options
                            ?.context as Business.DetailsResponse['place']) ??
                        undefined;

                    const hoursOfOperations =
                        validationContext?.hoursOfOperations;
                    const lastCall = this.parent?.lastCall;
                    const maxBuffer = getMaxSalesCutoffBufferMinutes(
                        hoursOfOperations,
                        lastCall
                    );

                    if (typeof maxBuffer !== 'number' || value <= maxBuffer) {
                        return true;
                    }

                    return this.createError({
                        message: `Max allowed is ${maxBuffer} minutes for the current last-call/close schedule.`,
                    });
                }
            ),
        orderPickupReminderCount: Yup.number()
            .integer()
            .positive()
            .min(1)
            .required(),
        orderPickupTrashDelayMinutes: Yup.number()
            .integer()
            .positive()
            .min(1)
            .required(),
        orderPickupPostReminderGraceMinutes: Yup.number()
            .integer()
            .positive()
            .min(1)
            .required(),
        maxDrinksPerOrder: Yup.number().integer().positive().min(1).required(),
        maxOrdersInQueue: Yup.number().integer().positive().min(1).required(),
    });
